import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Disable automatic scroll restoration to prevent scroll jumping
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}